exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.autocomplete[data-v-34ffb580] {\n  display: inline;\n}\n.dropdown-menu[data-v-34ffb580] {\n  border-style: solid;\n  border-width:  1px;\n}\nul>li[data-v-34ffb580] {\n  color: gray;\n  position: relative;\n}\nul>li[data-v-34ffb580]:hover {\n  color: black;\n}\n.active[data-v-34ffb580] {\n  color: white;\n  background-color: #0065B3;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-34ffb580","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/boxes/SpAutocompleteSelection.vue
// module id = 489
// module chunks = 0